export var AccessLevel = function (AccessLevel) {
  AccessLevel["Booker"] = "BOOKER";
  AccessLevel["BusinessPayManager"] = "BUSINESS_PAY_MANAGER";
  AccessLevel["BusinessPayUser"] = "BUSINESS_PAY_USER";
  AccessLevel["Self"] = "SELF";
  AccessLevel["Stayer"] = "STAYER";
  AccessLevel["Super"] = "SUPER";
  return AccessLevel;
}({});
export var ActionType = function (ActionType) {
  ActionType["BookingDetails"] = "BOOKING_DETAILS";
  ActionType["Ciol"] = "CIOL";
  ActionType["Directions"] = "DIRECTIONS";
  ActionType["Upsells"] = "UPSELLS";
  return ActionType;
}({});
export var AddressCorrespondenceEnum = function (AddressCorrespondenceEnum) {
  AddressCorrespondenceEnum["CardholderAlternativeAddress"] = "CARDHOLDER_ALTERNATIVE_ADDRESS";
  AddressCorrespondenceEnum["CompanyCorrespondenceAddress"] = "COMPANY_CORRESPONDENCE_ADDRESS";
  AddressCorrespondenceEnum["CompanyRegisteredAddress"] = "COMPANY_REGISTERED_ADDRESS";
  return AddressCorrespondenceEnum;
}({});
export var AddressType = function (AddressType) {
  AddressType["Business"] = "BUSINESS";
  AddressType["Home"] = "HOME";
  return AddressType;
}({});
export var AnswerType = function (AnswerType) {
  AnswerType["F"] = "F";
  AnswerType["U"] = "U";
  return AnswerType;
}({});
export var BasketPromoKind = function (BasketPromoKind) {
  BasketPromoKind["Generic"] = "GENERIC";
  BasketPromoKind["LandingPage"] = "LANDING_PAGE";
  BasketPromoKind["SiteWide"] = "SITE_WIDE";
  BasketPromoKind["Unique"] = "UNIQUE";
  return BasketPromoKind;
}({});
export var BatchStatus = function (BatchStatus) {
  BatchStatus["Cancelled"] = "CANCELLED";
  BatchStatus["Completed"] = "COMPLETED";
  BatchStatus["Expired"] = "EXPIRED";
  BatchStatus["Failed"] = "FAILED";
  BatchStatus["Pending"] = "PENDING";
  BatchStatus["Running"] = "RUNNING";
  return BatchStatus;
}({});
export var BookingAlertsFrequency = function (BookingAlertsFrequency) {
  BookingAlertsFrequency["A"] = "A";
  BookingAlertsFrequency["D"] = "D";
  BookingAlertsFrequency["M"] = "M";
  BookingAlertsFrequency["N"] = "N";
  BookingAlertsFrequency["W"] = "W";
  return BookingAlertsFrequency;
}({});
export var BookingType = function (BookingType) {
  BookingType["Business"] = "BUSINESS";
  BookingType["Leisure"] = "LEISURE";
  return BookingType;
}({});
export var CardStatus = function (CardStatus) {
  CardStatus["Cancelled"] = "CANCELLED";
  CardStatus["Current"] = "CURRENT";
  CardStatus["Hot"] = "HOT";
  CardStatus["NotActivated"] = "NOT_ACTIVATED";
  CardStatus["Pending"] = "PENDING";
  return CardStatus;
}({});
export var CardType = function (CardType) {
  CardType["Card"] = "CARD";
  CardType["None"] = "NONE";
  CardType["Piba"] = "PIBA";
  return CardType;
}({});
export var Channel = function (Channel) {
  Channel["Bb"] = "BB";
  Channel["Ccui"] = "CCUI";
  Channel["Distr"] = "DISTR";
  Channel["Employee"] = "EMPLOYEE";
  Channel["Pi"] = "PI";
  return Channel;
}({});
export var ChannelInfo = function (ChannelInfo) {
  ChannelInfo["Bb"] = "BB";
  ChannelInfo["Ccui"] = "CCUI";
  ChannelInfo["Distr"] = "DISTR";
  ChannelInfo["Employee"] = "EMPLOYEE";
  ChannelInfo["Pi"] = "PI";
  return ChannelInfo;
}({});
export var ChargeType = function (ChargeType) {
  ChargeType["AuthorizeCard"] = "AUTHORIZE_CARD";
  ChargeType["CardOnFile"] = "CARD_ON_FILE";
  ChargeType["CreditCard"] = "CREDIT_CARD";
  ChargeType["NoPayment"] = "NO_PAYMENT";
  return ChargeType;
}({});
export var ChatBotStatus = function (ChatBotStatus) {
  ChatBotStatus["Hide"] = "HIDE";
  ChatBotStatus["ShowAllPages"] = "SHOW_ALL_PAGES";
  ChatBotStatus["ShowLimitedPages"] = "SHOW_LIMITED_PAGES";
  return ChatBotStatus;
}({});
export var CiolStatusEnum = function (CiolStatusEnum) {
  CiolStatusEnum["CiolCompleted"] = "CIOL_COMPLETED";
  CiolStatusEnum["CiolStarted"] = "CIOL_STARTED";
  CiolStatusEnum["DkIssued"] = "DK_ISSUED";
  CiolStatusEnum["WalletPass"] = "WALLET_PASS";
  return CiolStatusEnum;
}({});
export var CompanyType = function (CompanyType) {
  CompanyType["Bb"] = "BB";
  CompanyType["Bp"] = "BP";
  CompanyType["Innb"] = "INNB";
  CompanyType["PibpOnly"] = "PIBP_ONLY";
  return CompanyType;
}({});
export var ContactSubType = function (ContactSubType) {
  ContactSubType["Landline"] = "landline";
  ContactSubType["Mobile"] = "mobile";
  return ContactSubType;
}({});
export var ContentPromoKind = function (ContentPromoKind) {
  ContentPromoKind["Generic"] = "GENERIC";
  ContentPromoKind["LandingPage"] = "LANDING_PAGE";
  ContentPromoKind["SiteWide"] = "SITE_WIDE";
  ContentPromoKind["Unique"] = "UNIQUE";
  return ContentPromoKind;
}({});
export var DashboardType = function (DashboardType) {
  DashboardType["FrequentBookings"] = "FREQUENT_BOOKINGS";
  DashboardType["PastSearches"] = "PAST_SEARCHES";
  DashboardType["RecentSearches"] = "RECENT_SEARCHES";
  DashboardType["UpcomingBooking"] = "UPCOMING_BOOKING";
  return DashboardType;
}({});
export var DirectDebitOption = function (DirectDebitOption) {
  DirectDebitOption["ByPost"] = "BY_POST";
  DirectDebitOption["Direct"] = "DIRECT";
  return DirectDebitOption;
}({});
export var EmployeeStatus = function (EmployeeStatus) {
  EmployeeStatus["Active"] = "ACTIVE";
  EmployeeStatus["Deactivated"] = "DEACTIVATED";
  EmployeeStatus["Inactive"] = "INACTIVE";
  EmployeeStatus["Purged"] = "PURGED";
  EmployeeStatus["Suspended"] = "SUSPENDED";
  return EmployeeStatus;
}({});
export var GroupOperator = function (GroupOperator) {
  GroupOperator["And"] = "AND";
  GroupOperator["Or"] = "OR";
  return GroupOperator;
}({});
export var Language = function (Language) {
  Language["De"] = "DE";
  Language["En"] = "EN";
  return Language;
}({});
export var PaymentOptionEnum = function (PaymentOptionEnum) {
  PaymentOptionEnum["Cc"] = "CC";
  PaymentOptionEnum["PibaCnp"] = "PIBA_CNP";
  PaymentOptionEnum["PibaCp"] = "PIBA_CP";
  return PaymentOptionEnum;
}({});
export var PaymentStatus = function (PaymentStatus) {
  PaymentStatus["NotRequired"] = "NOT_REQUIRED";
  PaymentStatus["PaymentRequired"] = "PAYMENT_REQUIRED";
  return PaymentStatus;
}({});
export var PaymentType = function (PaymentType) {
  PaymentType["AccountCompany"] = "ACCOUNT_COMPANY";
  PaymentType["Piba"] = "PIBA";
  PaymentType["ReserveWithoutCard"] = "RESERVE_WITHOUT_CARD";
  return PaymentType;
}({});
export var PibaRegistrationRole = function (PibaRegistrationRole) {
  PibaRegistrationRole["AccountHolder"] = "AccountHolder";
  PibaRegistrationRole["Cardholder"] = "Cardholder";
  PibaRegistrationRole["CostCenterUser"] = "CostCenterUser";
  PibaRegistrationRole["CostCentreHolder"] = "CostCentreHolder";
  PibaRegistrationRole["FinanceUser"] = "FinanceUser";
  return PibaRegistrationRole;
}({});
export var PromoBoxStatus = function (PromoBoxStatus) {
  PromoBoxStatus["CodeAlreadyApplied"] = "CODE_ALREADY_APPLIED";
  PromoBoxStatus["CodeExpired"] = "CODE_EXPIRED";
  PromoBoxStatus["Empty"] = "EMPTY";
  PromoBoxStatus["Invalid"] = "INVALID";
  PromoBoxStatus["MaxRoomsExceeded"] = "MAX_ROOMS_EXCEEDED";
  PromoBoxStatus["MinRoomsNotMet"] = "MIN_ROOMS_NOT_MET";
  PromoBoxStatus["Success"] = "SUCCESS";
  PromoBoxStatus["Unavailable"] = "UNAVAILABLE";
  return PromoBoxStatus;
}({});
export var PromoKind = function (PromoKind) {
  PromoKind["Generic"] = "GENERIC";
  PromoKind["LandingPage"] = "LANDING_PAGE";
  PromoKind["SiteWide"] = "SITE_WIDE";
  PromoKind["Unique"] = "UNIQUE";
  return PromoKind;
}({});
export var QuestionLocation = function (QuestionLocation) {
  QuestionLocation["B"] = "B";
  QuestionLocation["R"] = "R";
  return QuestionLocation;
}({});
export var RegistrationRole = function (RegistrationRole) {
  RegistrationRole["AccountCardHolder"] = "ACCOUNT_CARD_HOLDER";
  RegistrationRole["AccountHolder"] = "ACCOUNT_HOLDER";
  RegistrationRole["CardHolder"] = "CARD_HOLDER";
  RegistrationRole["CostCentreUser"] = "COST_CENTRE_USER";
  RegistrationRole["FinanceUser"] = "FINANCE_USER";
  RegistrationRole["FinanceUserCardHolder"] = "FINANCE_USER_CARD_HOLDER";
  return RegistrationRole;
}({});
export var RegistrationRoles = function (RegistrationRoles) {
  RegistrationRoles["AccountCardHolder"] = "ACCOUNT_CARD_HOLDER";
  RegistrationRoles["AccountHolder"] = "ACCOUNT_HOLDER";
  RegistrationRoles["CardHolder"] = "CARD_HOLDER";
  RegistrationRoles["CostCentreUser"] = "COST_CENTRE_USER";
  RegistrationRoles["FinanceUser"] = "FINANCE_USER";
  RegistrationRoles["FinanceUserCardHolder"] = "FINANCE_USER_CARD_HOLDER";
  return RegistrationRoles;
}({});
export var RoomTypeFilter = function (RoomTypeFilter) {
  RoomTypeFilter["Db"] = "DB";
  RoomTypeFilter["Dis"] = "DIS";
  RoomTypeFilter["Fam"] = "FAM";
  RoomTypeFilter["Sb"] = "SB";
  RoomTypeFilter["Twin"] = "TWIN";
  return RoomTypeFilter;
}({});
export var Scheme = function (Scheme) {
  Scheme["De"] = "DE";
  Scheme["Gb"] = "GB";
  return Scheme;
}({});
export var SortingOption = function (SortingOption) {
  SortingOption["Distance"] = "DISTANCE";
  SortingOption["Price"] = "PRICE";
  return SortingOption;
}({});
export var UserType = function (UserType) {
  UserType["Agent"] = "AGENT";
  UserType["Business"] = "BUSINESS";
  UserType["Leisure"] = "LEISURE";
  return UserType;
}({});
export var FlowType = function (FlowType) {
  FlowType["CheckInOnline"] = "CheckInOnline";
  return FlowType;
}({});